"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDKOptionsValidator = void 0;
const base_58_1 = __importDefault(require("base-58"));
const js_sha256_1 = require("js-sha256");
const common_1 = require("@bugfender/common");
class SDKOptionsValidator {
    constructor(browser) {
        this.browser = browser;
        this.rules = {
            appKey: ['required', 'string'],
            apiURL: ['string', 'url'],
            build: ['string'],
            baseURL: ['string', 'url'],
            debug: ['boolean'],
            deviceName: ['string'],
            overrideConsoleMethods: ['boolean'],
            printToConsole: ['boolean'],
            logBrowserEvents: ['boolean'],
            logUIEvents: ['boolean'],
            registerErrorHandler: ['boolean'],
            version: ['string'],
        };
    }
    init(options) {
        options = (0, common_1.prepareOptions)(options);
        (0, common_1.validate)(options, this.rules);
        return Object.assign({ appID: base_58_1.default.encode(js_sha256_1.sha256.array(options.appKey)).substring(0, 10), apiURL: 'https://api.bugfender.com', baseURL: 'https://dashboard.bugfender.com', debug: false, deviceName: this.browser.getDeviceName(), overrideConsoleMethods: true, printToConsole: true, logBrowserEvents: true, logUIEvents: true, registerErrorHandler: true, version: '0.0.0', build: '0' }, options);
    }
}
exports.SDKOptionsValidator = SDKOptionsValidator;
